<template>
  <div class="contact-card">
    <div class="row">
      <div class="col-md-7">
        <div class="row">
          <div class="col-xs-3 col-md-5 text-right">
            <strong>Nom:</strong>
          </div>
          <div class="col-xs-6 col-md-7">
            <div v-show="!editMode" class="contact-field-preview" :class="{ 'za_editbox': !readOnly }" v-on:click="enableEdit">{{ edit.first_name }} {{ edit.last_name }}</div>
            <div v-show="editMode" class="contact-field-group" :class="{ 'has-error': errors.hasOwnProperty('either_name') }" >
              <input type="text" class="contact-field" ref="focusField" placeholder="Prénom" v-model="edit.first_name"/>
              <input type="text" class="contact-field" placeholder="Nom" v-model="edit.last_name"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3 col-md-5 text-right">
            <strong>Position:</strong>
          </div>
          <div class="col-xs-7">
            <div v-show="!editMode" class="contact-field-preview" :class="{ 'za_editbox': !readOnly }" v-on:click="enableEdit">{{ edit.position }}</div>
            <input v-show="editMode" type="text" class="contact-field" placeholder="Position" v-model="edit.position"/>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3 col-md-5 text-right">
            <strong>Téléphone:</strong>
          </div>
          <div class="col-xs-7">
            <div v-show="!editMode" class="contact-field-preview" :class="{ 'za_editbox': !readOnly }" v-on:click="enableEdit">{{ edit.telephone }}</div>
            <input v-show="editMode" type="text" class="contact-field" placeholder="Téléphone" v-model="edit.telephone" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-3 col-md-5 text-right">
            <strong>Courriel:</strong>
          </div>
          <div class="col-xs-7">
            <div v-show="!editMode" class="contact-field-preview" :class="{ 'za_editbox': !readOnly }" v-on:click="enableEdit">{{ edit.email }}</div>
            <div v-show="editMode" :class="{ 'has-error': errors.hasOwnProperty('email') }" >
              <input type="email" class="contact-field" placeholder="Courriel" v-model="edit.email"
                ref="email" 
                pattern="^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-9 col-xs-offset-3 col-md-5 col-md-offset-0 contact-actions">
        <div class="contact-action contact-action-active-contact form-check">
          <label class="form-radio-input contact-active-label" v-if="showIsActiveToggle === undefined || showIsActiveToggle">
            <input class="form-check-input" type="checkbox" v-model="edit.is_active" @change="updateIsActive">
              <template v-if="isActiveLabel">
                {{ isActiveLabel }}
              </template>
              <template v-else>
                Contact Actif
              </template>
          </label>

          <span v-if="!isNew && !readOnly" style="margin-left: 3em;"><a v-on:click="confirmDeleteContact(contact.contact_id)" style="cursor:pointer"><em class="fas fa-trash-alt" aria-hidden="true"></em></a></span>
        </div>
        <div class="contact-action" v-show="editMode">  
          <button type="button" class="btn btn-primary btn-sm" v-on:click="save">
            <i class="fas fa-save" aria-hidden="true"></i>
            <template v-if="!isNew"> Enregistrer</template>
            <template v-else> Ajouter</template>
          </button>
          <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEdit">Annuler</button>
        </div>
      </div>
    </div>
    <div v-if="hasErrors" class="row">
      <div class="col-xs-12 text-center">
        <p class="text-danger" v-for="(error, key) in errors" :key="key"><small>{{ error }}</small></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .contact-card {
    max-width: 600px;
    margin: 0.5rem 0 2rem;
  }

  .contact-card:last-child {
    margin-bottom: 1rem;
  }

  .contact-field-preview {
    word-break: break-all
  }

  .contact-card .za_editbox {
    padding: 0 0.2em;
    margin: 0 -0.2em 0.2em;
    margin-right: 0.2em;
    min-height: 1.57em;
    border-radius: 0;
  }

  .contact-card .contact-field {
    border: none;
    padding: 0 0.2em;
    margin: 0 -0.2em 0.2em;
    background: #eee;
    margin-right: 0.5em;
    display: inline-block;
  }

  .contact-card .has-error .contact-field, .contact-card .contact-field:invalid {
    outline: 1px solid #a94442;
  }

  .contact-card .has-error .contact-field::placeholder {
    color: #a94442;
  }

  .contact-card .contact-field-group {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
  }

  .contact-card .contact-field-group .contact-field {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: 100%;
  }
  .contact-card .contact-field-group .contact-field:last-child {
    flex-grow: 1;
  }

  .contact-card .contact-field::placeholder {
    color: #999;
  }

  @media screen and (min-width: 992px) {
    .contact-actions {
      pointer-events: none;
      min-height: 8em;
    }

    .contact-action {
      pointer-events: all;
    }
  }

  @media screen and (min-width: 992px) {
    .contact-action-active-contact {
      margin-top: 3.5em;
    }
  }

  .contact-active-label {
    cursor: pointer;
  }
</style>

<script>
/* eslint-disable */
import Vue from 'vue'

const defaultContact = {
  contact_id: null,
  first_name: "",
  last_name: "",
  email: "",
  telephone: "",
  position: "",
  is_active: false
}
export default {
  props: ['contact', 'isNew', 'readOnly', 'showIsActiveToggle', 'isActiveLabel'],
  data: function() {
    return {
      editMode: false,
      edit: defaultContact,
      errors: {}
    }
  },
  watch: {
    contact: function(newVal) {
      this.edit = JSON.parse(JSON.stringify(newVal))
    },
    editMode: function(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.overrideEditContactFromProp()
        this.errors = {}
      }
    },
    'edit.email': function() {
      if (this.errors.email === '') { return }

      console.log(this.$refs.email.validity)

      if (this.$refs.email && this.$refs.email.validity && !this.$refs.email.validity.patternMismatch) {
        Vue.delete(this.errors, 'email')
      }
    }
  },
  mounted: function() {
    this.overrideEditContactFromProp()
    
    if (this.isNew) {
      this.editMode = true
    }
  },
  computed: {
    hasErrors() {
      return Object.keys(this.errors).length > 0
    }
  },
  methods: {
    overrideEditContactFromProp() {
      if (this.contact !== undefined) {
        this.edit = JSON.parse(JSON.stringify(this.contact))
      } else if (this.isNew) {
        this.edit = JSON.parse(JSON.stringify(defaultContact))
      }
    },
    enableEdit(event) {
      if (this.readOnly) {
        return
      }
      this.editMode = true

      Vue.nextTick(() => {
        const el = event.target
        const associatedField = el.parentNode.querySelector('input[type="text"]')
        if (associatedField) {
          associatedField.focus()
        }
      })
    },
    save() {
      if (this.edit.first_name === "" && this.edit.last_name === "") {
        Vue.set(this.errors, 'either_name', 'Indiquer au minimum soit un prénom ou un nom pour ce contact')
        return
      } else {
        Vue.delete(this.errors, 'either_name')
      }

      if (this.$refs.email && this.$refs.email.validity && this.$refs.email.validity.patternMismatch) {
        Vue.set(this.errors, 'email', this.$messages.email)
        return
      } else {
        Vue.delete(this.errors, 'email')
      }

      this.$emit('save', this.edit)

      this.editMode = false
      this.overrideEditContactFromProp()
    },
    cancelEdit() {
      this.editMode = false
      this.errors = {}
      this.overrideEditContactFromProp()
    
      this.$emit('cancel')
    },
    focus() {
      this.editMode = true
      Vue.nextTick(() => {
        this.$refs.focusField.focus()
      })
    },
    updateIsActive() {
      if (this.editMode == false) {
        this.$emit('update-is-active', this.edit.contact_id, this.edit.is_active)
      }
    },
    confirmDeleteContact(contact_id) {
      this.$emit('confirm-delete-contact', contact_id)
    }
    
  }
}
</script>